import { render } from "./pdf-js-viewer.vue?vue&type=template&id=5296a986&scoped=true"
import script from "./pdf-js-viewer.vue?vue&type=script&lang=js"
export * from "./pdf-js-viewer.vue?vue&type=script&lang=js"

import "./pdf-js-viewer.vue?vue&type=style&index=0&id=5296a986&scoped=true&lang=css"
import "./pdf-js-viewer.vue?vue&type=style&index=1&id=5296a986&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5296a986"]])

export default __exports__